import type { QueryClient } from "@tanstack/react-query";

import { resetBetslipForLogout } from "@/stores/Betslip";

// Single place that drops ALL per-user client state when a session ends. Both
// the explicit sign-out and the cross-tab / remote-terminate paths call this so
// the behaviour cannot drift between them (Rule 6). Anything user-scoped kept
// on the client belongs here.
export const clearClientUserState = (queryClient: QueryClient): void => {
  // Server-state cache (react-query).
  queryClient.clear();
  // Persisted betslip (localStorage) — otherwise the next user on this device
  // inherits the previous user's slip.
  resetBetslipForLogout();
};
